export default function issueCertificateCommonApis($apiInstance, $store) {
    return {
        getCustomerInfoByMobile: async (customerMobile) => {
            try {
                const response = await $apiInstance.get(`/customers/by/mobile/${customerMobile}`);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getCustomerInfoByMobileAndSendChannel: async (customerMobile, sendChannel) => {
            try {
                const response = await $apiInstance.get(`/customers/by/mobile/v2/${sendChannel}/${customerMobile}`);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        updateCustomerInfo: async (customerId, obj) => {
            try {
                const response = await $apiInstance.put(`/customers/${customerId}`, obj);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getCustomerListByName: async (textInput) => {
            try {
                const response = await $apiInstance.post('customers/search', textInput);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getHospitalMetadata: async () => {
            try {
                const response = await $apiInstance.get('/companies/hospital/metadata');
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getAgreements: async () => {
            try {
                const response = await $apiInstance.get('/agreements');
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getWarrantyAndAfterSurgery: async (dept, surgeryType) => {
            try {
                const response = await $apiInstance.get(`/companies/warranty/template/${dept}/${surgeryType}`);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        getSingleTranslation: async(params) => {
            $store.commit('setIsLoading', true);
            try {
                const response = await $apiInstance.post(`/companies/management/warranty/translate/single`, params);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch(error) {
                console.log(error);
                throw error;
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        getBulkTranslation: async(params) => {
            $store.commit('setIsLoading', true);
            try {
                const response = await $apiInstance.post(`/companies/management/warranty/translate/bulk`, params);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch(error) {
                console.log(error);
                throw error;
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        requestIssueCertificate: async (obj) => {
            $store.commit('setIsLoading', true);
            try {
                const response = await $apiInstance.post('/nfts', obj);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                $store.commit('setIsLoading', false);
                return response.data;
            } catch (error) {
                console.log(error);
                $store.commit('setIsLoading', false);
                throw error;
            }
        },
        /**
         * 환경 설정 다건 조회
         * @param {string[]} configKeys - 조회할 환경 설정 키 배열
         * @returns {Promise<Object[]>} 환경 설정 객체 배열
         */
        getEnvConfigsBulk: async (configKeys) => {
            try {
                const queryString = configKeys.join(',');
                const response = await $apiInstance.get(`/env-configs/bulk?configKeys=${queryString}`);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        /**
         * 발행 화면에서 사용되는 제조사들의 정보 및 순서 정보
         * @param {string} medicalDept - 진료과목
         * @param {string} productType - 제품 타입(영어로)
         * @returns {Promise<Object[]>} 제조사 정보 배열
         */
        getManufacturerList: async ({medicalDept, productType}) => {
            try {
                const response = await $apiInstance.get(`/accounts/issue/manufacturers/${medicalDept}/${productType}`);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
                /**
         * 발행 화면의 제조사 순서 저장
         * @param {string} medicalDept - 진료과목
         * @param {string} productType - 제품 타입
         * @param {Array} manufacturers - 제조사 정보 배열
         * @returns {Promise<Object>} 저장 결과
         */
        setManufacturerList: async ({medicalDept, productType, manufacturers}) => {
            try {
                const response = await $apiInstance.put(`/accounts/issue/manufacturers/${medicalDept}/${productType}`, manufacturers);
                if(!response.status === 200 && !response.status === 201) throw new Error('wrong status code');
                if(response.message) throw new Error(response.message);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
    }
}
